//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const OpenSearchStemming: FeatureFlag = {"Id":"OpenSearchStemming","Label":"[10.17]OpenSearchStemming","Impact":"Enable stemming term subfields for OpenSearch datasource text columns.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
